module.exports = __webpack_public_path__ + "img/theme-default.ebe61609.png";